const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async createSupplier({ rootState }, params = {}) {
      const data = await rootState.http("/supplier/createSupplier", params);
      return data;
    },
    async updateSupplier({ rootState }, params = {}) {
      const data = await rootState.http("/supplier/updateSupplier", params);
      return data;
    },
    async getSettleMethodList({ rootState }, params = {}) {
      const data = await rootState.http("/supplier/getBalanceWay", params);
      return data;
    },
    async getSupplierList({ rootState }, params = {}) {
      const data = await rootState.http("/supplier/querySupplierList", params);
      return data;
    },
    async getSupplierDetail({ rootState }, params = {}) {
      const data = await rootState.http("/supplier/getSupplierByCode", params);
      return data;
    },
    async updateStatus({ rootState }, params = {}) {
      const data = await rootState.http("/supplier/batchUpdateStatus", params);
      return data;
    }
  }
};

export default store;
